import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import { UseEntityStore } from "../../common/entityStore";
import { MailProductCode } from "../../common/enum";
import { UseListStore } from "../../common/listStore";
import { TmOrderDto, ProductDto, setContOrder, setMailOrder } from "./common";
import { getResource } from "../../common/localization";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.Order." + key, defaultMessage) as string;
}

export function OrderTypeSelect({ useStore, useProductsStore }: {
    useStore: UseEntityStore<TmOrderDto>;
    useProductsStore: UseListStore<ProductDto>;
}) {
    const mailProduct = useProductsStore(p => p.items.find(p => p.code === MailProductCode));
    const nonMailProducts = useProductsStore(p => p.items.filter(p => p.code !== MailProductCode));
    return <Grid container spacing={2}>
        {mailProduct && <Grid item width={300}>
            <Card onClick={() => setMailOrder(useStore, mailProduct)} style={{ cursor: "pointer" }}>
                <CardContent>
                    <Box mb={2}>
                        <Grid container direction="row" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="h5" color="textPrimary" component="h2">
                                    {getText("MailOrder")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
                <CardActions>
                    <Box>
                        <Button>{getResource("Ui.Select")}</Button>
                    </Box>
                </CardActions>
            </Card>
        </Grid>}
        {nonMailProducts && <Grid item width={300}>
            <Card onClick={() => setContOrder(useStore, nonMailProducts)} style={{ cursor: "pointer" }}>
                <CardContent>
                    <Box mb={2}>
                        <Grid container direction="row" alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="h5" color="textPrimary" component="h2">
                                    {getText("ContinuityOrder")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
                <CardActions>
                    <Box>
                        <Button>{getResource("Ui.Select")}</Button>
                    </Box>
                </CardActions>
            </Card>
        </Grid>}
    </Grid>;
}
